import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowHideColumnsComponent } from './components/show-hide-columns/show-hide-columns.component';
import { RearrangeColumnsComponent } from './components/rearrange-columns/rearrange-columns.component';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { DragDropModule } from '@angular/cdk/drag-drop';



@NgModule({
  declarations: [ShowHideColumnsComponent, RearrangeColumnsComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    MatGridListModule,
    MatButtonModule,
    DragDropModule
  ]
})
export class TableColumnsModule { }
